///Script responsible for the brand display order within the alphabetical listing
///algorithm adjusts when screen size (and number of columns) adjusts/resizes
(function ($) {
    var selectors = {
        brandLink: '.js-brand',
        brandList: '.js-brand-list'
    },
        $brands2Column,
        $brands3Column,
        $brands4Column,
        numberOfColumns;

    function adjustBrandSorting() {
        //first determine what the number of columns is
        //to see if we need to update the lists
        var newNumberOfColumns = 1;
        if ($brands2Column.is(':visible')) {
            newNumberOfColumns = 2;
        } else if ($brands3Column.is(':visible')) {
            newNumberOfColumns = 3;
        } else if ($brands4Column.is(':visible')) {
            newNumberOfColumns = 4;
        }

        if (numberOfColumns === newNumberOfColumns) {
            return;
        }
        console.log(newNumberOfColumns);
        numberOfColumns = newNumberOfColumns;

        //loop through each list (brand listing letter)
        //and determine what the new sort order should be
        //based on the new number of columns and the total
        //number of brands in the list
        $(selectors.brandList).each(function () {
            var $brandList = $(this),
                $brands = $brandList.find(selectors.brandLink),
                numberOfBrands = $brands.size(),
                sortedIndices = [];

            for (var i = 0, r = 0, c = 0; i < numberOfBrands; i++) {
                sortedIndices[i] = r + c * numberOfColumns;

                if (r + (c + 1) * numberOfColumns < numberOfBrands) {
                    c++;
                } else {
                    c = 0;
                    r++;
                }
            }

            var sortedBrands = [], originalIndex;
            $brands.each(function (elIndex) {
                var $brand = $(this);

                if (!$brand.data('original-index')) {
                    $brand.data('original-index', elIndex);
                }

                originalIndex = $brand.data('original-index');
                sortedBrands[sortedIndices[originalIndex]] = $brand;
            });

            $brands.detach();
            $brandList.html(sortedBrands);
        });
    }

    $(function () {
        $brands2Column = $('#brands-2-col');
        $brands3Column = $('#brands-3-col');
        $brands4Column = $('#brands-4-col');

        adjustBrandSorting();

        evo.$.window.on('resize', adjustBrandSorting);
    });
})(jQuery);